/*----- Core -----*/
import React     				from 'react'
import styled, { css }  from 'styled-components'
import PropTypes        from 'prop-types'

/*----- Assets -----*/

/*----- Commons-----*/
import Montserrat from '../../commons/mixins/fonts/Montserrat'
import Color      from '../../commons/Color'

const StyledDashboardProducerItem = styled.article`
	padding: 16px;
  border-radius: 8px;
	display: grid;
	grid-template-columns: 32px 200px 200px auto;
	align-items: center;
	.dashboard-producer-item__number {
		${ Montserrat(10, 600, 'white') };
    background: ${ Color.grey };
    height: 16px;
    width: 16px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
	}
	.dashboard-producer-item__title {
		${ Montserrat(10, 400, Color.grey) }
	}	
	.dashboard-producer-item__value {
		${ Montserrat(14, 600, Color.grey) }
	}
	.dashboard-producer-item__actions {
		margin-left: 16px;
		padding-left: 16px;
		display: flex;
		justify-content: flex-end;
	}
	.dashboard-producer-item__button {
		${ Montserrat(12, 600, Color.grey) }
		margin: 0 8px;
		width: 32px;
    text-align: center;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
		border: none;
		background: none;
		cursor: pointer;
	}
	${props => props.invert && css`
		background-color: #f7f7f7;
  `}
`

/*----- Export -----*/
const DashboardProducerItem = ({ i, name, lastname, mat_number, invert, redirectToUpdate }) => {
	return (
		<StyledDashboardProducerItem className="dashboard-producer-item" invert={invert}>
			<div className="dashboard-producer-item__number">{i}</div>
			<div>
				<div className="dashboard-producer-item__title">{ lastname }</div>
				<div className="dashboard-producer-item__vale">{ name }</div>
			</div>
			<div>
				<div className="dashboard-producer-item__title">MAT SNN</div>
				<div className="dashboard-producer-item__value">{ mat_number }</div>
			</div>
			<div className="dashboard-producer-item__actions">
				<button className="dashboard-producer-item__button" onClick={redirectToUpdate}>editar</button>
			</div>
		</StyledDashboardProducerItem>
	)
}
export default DashboardProducerItem

/*----- PropTypes -----*/
DashboardProducerItem.propTypes = {
	i:   			 PropTypes.number,
	date:      PropTypes.object,
	brochure:  PropTypes.array,
  name:	 		 PropTypes.string.isRequired,
	invert:    PropTypes.number,
	readUrl:   PropTypes.string,
	updateUrl: PropTypes.string
}
